import useGlobals from '../../hooks/useGlobals';
import React, { useMemo } from 'react';
import Nav, { Link } from './Nav';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
const Subnav = () => {
  const { wfSubnavSections: sections, wfSubnavConfig: config } = useGlobals([
    'wfSubnavSections',
    'wfSubnavConfig',
  ]);

  const links = useMemo(() => {
    if (!sections) return;
    return sections.map((s, i) => (
      <Link href={'#' + s.id} index={i} key={s.id}>
        {s.displayName}
      </Link>
    ));
  }, [sections]);

  if (!sections || !config) return null;
  return <Nav config={config}>{links}</Nav>;
};

export default Subnav;
